// extracted by mini-css-extract-plugin
export default {"container":"FeaturedSandboxesView_container__Bq6HH","featured":"FeaturedSandboxesView_featured__wyjF8","list":"FeaturedSandboxesView_list__uXZma"};